module.exports = __webpack_public_path__ + "img/padlock-selected-white.81b9dd35.png";